import React from 'react';
import { export_csv_teacher_program_pacings_path } from '@/modules/routes';
import Icon from '@/components/ui/Icon';
import Text from '@/components/ui/Text';

type ExportCsvButtonProps = {
  programId: number;
};

const ExportCsvButton = ({ programId } : ExportCsvButtonProps) => {
  const exportCsvUrl = export_csv_teacher_program_pacings_path(programId, { format: 'csv' });

  return (
    <a
      className="tw-px-2.5 tw-py-1.5 btn btn--purple tw-flex tw-items-center tw-gap-2"
      href={exportCsvUrl}
    >
      <Icon height={16} icon="DownloadExcel" width={16} />
      <Text size="sm" variant="body" weight="normal"> Export CSV </Text>
    </a>
  );
};

export default ExportCsvButton;
